import { Divider, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import BookmarkPlan from "components/common/Bookmark";
import Button from "components/common/Button";
import HTMLRenderer from "components/common/HTMLRenderer";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import {
  abovePropertyViewTypePlan,
  abovePropertyViewTypeTemplate,
  accessTypes,
  DEFAULT_CORP_INNCODE
} from "utils/CommonConstants";
import { getHoursAndMin, getPlanDuration, isAboveUserPlanBookmarked, isBookmarked } from "utils/CommonFunctions";
import { setisBookmarked } from "../../../planDetails/PlanDetail.slice";
import { clearFilter, setSearchText } from "../../AboveProperty.slice";
interface Props {
  isTemplatePlan: boolean;
  setMultiplansAssign?: any;
}

export default function PlanDetails(props: Props) {
  const { isTemplatePlan, setMultiplansAssign } = props;
  const multiTargetDetails = useAppSelector((state) => state.aboveProperty.planProgressMultiTarget);
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const planDetails = isTemplatePlan ? myPlanDetails : multiTargetDetails;

  const getTimeData = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        display="flex"
        gap={"8px"}
        alignSelf="right"
        justifyContent={{ xs: "space-between", sm: "flex-end" }}
        alignItems={"center"}
        marginTop={{ xs: "16px", sm: 0 }}
      >
        <Grid item display={"flex"} flexDirection={"row"} gap={"8px"} alignItems={"center"}>
          <>
            <BookmarkPlan
              aboveUserPayload={{
                isAboveUsertype: true,
                viewType: isTemplatePlan ? abovePropertyViewTypeTemplate : abovePropertyViewTypePlan
              }}
              cmsId={planDetails?.id}
              isBookmarked={isAboveUserPlanBookmarked(
                planDetails?.id,
                isTemplatePlan ? "bookmarkedTemplate" : "bookmarkedIdList"
              )}
            />
            <Divider
              sx={{
                height: "12px",
                width: "1px",
                backgroundColor: tokens.Border.General.Secondary
              }}
              orientation="vertical"
            ></Divider>
          </>

          <Timing
            duration={
              isTemplatePlan ? getPlanDuration(planDetails?.sections) : getHoursAndMin(planDetails?.timeEstimateMinutes)
            }
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Grid container sx={{ backgroundColor: tokens.Background.General.Primary }} padding="20px">
      {isMobileScreen && getTimeData()}{" "}
      <Grid item xs={12} display="flex" sx={{ flexDirection: { xs: "column", sm: "row" } }}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" showBold color={tokens.Text.General.PrimaryHeadline}>
            {planDetails?.name}
          </Typography>
        </Grid>

        {!isMobileScreen && getTimeData()}
      </Grid>
      <Grid item xs={12} marginTop={"10px"} sx={{ overflowWrap: "break-word" }}>
        <Typography component="div" variant={"body2"} color={tokens.Text.General.PrimaryBody}>
          <HTMLRenderer content={planDetails?.summary} />
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        marginTop={"10px"}
        display="flex"
        flexDirection={isMobileScreen ? "column" : "row"}
        justifyContent={"flex-end"}
        gap={1}
      >
        <Button
          sx={{ width: isMobileScreen ? "100%" : "" }}
          variant="secondary"
          label="Plan Details"
          onClick={() => {
            dispatch(setisBookmarked(isBookmarked(planDetails?.id)));

            isTemplatePlan
              ? navigate(`/myplandetails/${planDetails?.id}`)
              : navigate(`/plandetails/${planDetails?.id}`, {
                  state: { innCode: DEFAULT_CORP_INNCODE, redirectFromDashboard: true }
                });
          }}
        />
        <Button
          sx={{ width: isMobileScreen ? "100%" : "" }}
          variant="primary"
          label="Assign Plan"
          accessType={accessTypes.assign}
          onClick={() => {
            dispatch(clearFilter({ parentView: "dialogFilters", filterType: "planAssignment" }));
            dispatch(
              setSearchText({
                inputText: "",
                searchType: "planAssignment",
                filterName: "searchText",
                parentView: "dialogFilters"
              })
            );
            if (myPlanDetails?.totalCards === 0 && isTemplatePlan)
              dispatch(
                setFeedbackDetails({
                  shouldShow: true,
                  setState: setFeedbackDetails({ shouldShow: false }),
                  message: "The plan cannot be assigned as there are no action cards for the plan"
                })
              );
            else setMultiplansAssign(true);
          }}
        />
      </Grid>
    </Grid>
  );
}
